interface BenefitRow {
  serviceCategory: string;
  planPays: string;
  limitations: string;
}

interface InsuranceBenefitsTableProps {
  data: BenefitRow[];
}

export function InsuranceBenefitsTable({ data }: InsuranceBenefitsTableProps) {
  if (!data || data.length === 0) {
    return (
      <div className='rounded-xl border p-8 text-center' style={{ borderColor: '#E5E7EB', backgroundColor: '#F9FAFB' }}>
        <p className='text-sm text-gray-500'>No benefits data available</p>
      </div>
    );
  }

  return (
    <div className='overflow-x-auto rounded-xl border' style={{ borderColor: '#E5E7EB' }}>
      <table className='w-full'>
        <thead style={{ backgroundColor: 'var(--clinic-primary)', opacity: 0.05 }}>
          <tr>
            <th className='px-6 py-4 text-left text-xs font-semibold uppercase tracking-wider' style={{ color: 'var(--clinic-text)' }}>
              Service Category
            </th>
            <th className='px-6 py-4 text-left text-xs font-semibold uppercase tracking-wider' style={{ color: 'var(--clinic-text)' }}>
              Plan Pays
            </th>
            <th className='px-6 py-4 text-left text-xs font-semibold uppercase tracking-wider' style={{ color: 'var(--clinic-text)' }}>
              Limitations
            </th>
          </tr>
        </thead>
        <tbody className='divide-y divide-gray-200'>
          {data.map((row, index) => (
            <tr
              key={index}
              className='transition-colors duration-200 hover:bg-gray-50'
            >
              <td className='px-6 py-4 text-sm font-medium' style={{ color: 'var(--clinic-text)' }}>
                {row.serviceCategory}
              </td>
              <td className='px-6 py-4 text-sm' style={{ color: 'var(--clinic-text)' }}>
                {row.planPays}
              </td>
              <td className='px-6 py-4 text-sm text-gray-600'>
                {row.limitations}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

